/**
 * Miradi Share UX Services
 * Miradi Share UX Services end-point (for internal use only)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { GoalNew } from './goalNew';
import { IndicatorNew } from './indicatorNew';
import { IndicatorFutureStatusNew } from './indicatorFutureStatusNew';
import { TaxonomyClassificationNew } from './taxonomyClassificationNew';
import { IndicatorMeasurementNew } from './indicatorMeasurementNew';


/**
 * Goal and related (created via SMART guide)
 */
import { ValidateUtils } from 'app/shared/utils';

export class SmartGoalNew { 
    goal?: GoalNew;
    /**
     * Goal taxonomy classifications
     */
    goalTaxonomyClassifications?: Array<TaxonomyClassificationNew>;
    indicator?: IndicatorNew;
    /**
     * Indicator taxonomy classifications
     */
    indicatorTaxonomyClassifications?: Array<TaxonomyClassificationNew>;
    indicatorFutureStatus?: IndicatorFutureStatusNew;
    indicatorMeasurement?: IndicatorMeasurementNew;

    constructor(item?: Partial<SmartGoalNew>) {
        
        Object.assign(this, item);
    }

    static getValidationObject(): any {
        return {
            goal: {
                
                
                
                isValid: (itemOrValue: any) => {
                    let result = true;

                    let value = itemOrValue === Object(itemOrValue) ? itemOrValue.goal : itemOrValue;

                    if (['uuid'].indexOf('') === -1 || value != null) {
                      result = result && ValidateUtils.isValidLength(value, null, );
                    }

                    return result;
                }
            },
            goalTaxonomyClassifications: {
                
                
                
                isValid: (itemOrValue: any) => {
                    let result = true;

                    let value = itemOrValue === Object(itemOrValue) ? itemOrValue.goalTaxonomyClassifications : itemOrValue;

                    if (['uuid'].indexOf('') === -1 || value != null) {
                      result = result && ValidateUtils.isValidLength(value, null, );
                    }

                    return result;
                }
            },
            indicator: {
                
                
                
                isValid: (itemOrValue: any) => {
                    let result = true;

                    let value = itemOrValue === Object(itemOrValue) ? itemOrValue.indicator : itemOrValue;

                    if (['uuid'].indexOf('') === -1 || value != null) {
                      result = result && ValidateUtils.isValidLength(value, null, );
                    }

                    return result;
                }
            },
            indicatorTaxonomyClassifications: {
                
                
                
                isValid: (itemOrValue: any) => {
                    let result = true;

                    let value = itemOrValue === Object(itemOrValue) ? itemOrValue.indicatorTaxonomyClassifications : itemOrValue;

                    if (['uuid'].indexOf('') === -1 || value != null) {
                      result = result && ValidateUtils.isValidLength(value, null, );
                    }

                    return result;
                }
            },
            indicatorFutureStatus: {
                
                
                
                isValid: (itemOrValue: any) => {
                    let result = true;

                    let value = itemOrValue === Object(itemOrValue) ? itemOrValue.indicatorFutureStatus : itemOrValue;

                    if (['uuid'].indexOf('') === -1 || value != null) {
                      result = result && ValidateUtils.isValidLength(value, null, );
                    }

                    return result;
                }
            },
            indicatorMeasurement: {
                
                
                
                isValid: (itemOrValue: any) => {
                    let result = true;

                    let value = itemOrValue === Object(itemOrValue) ? itemOrValue.indicatorMeasurement : itemOrValue;

                    if (['uuid'].indexOf('') === -1 || value != null) {
                      result = result && ValidateUtils.isValidLength(value, null, );
                    }

                    return result;
                }
            },
            isValid: SmartGoalNew.isValid,
        };
    }

    static isValid(obj: SmartGoalNew): boolean {
        if (!!obj) {
            const item = obj as any; // just to make things easier in this generated code...
            const validationObject = SmartGoalNew.getValidationObject();
            let result = !item.$validationMessage;
            result = result && validationObject.goal.isValid(item);
            result = result && validationObject.goalTaxonomyClassifications.isValid(item);
            result = result && validationObject.indicator.isValid(item);
            result = result && validationObject.indicatorTaxonomyClassifications.isValid(item);
            result = result && validationObject.indicatorFutureStatus.isValid(item);
            result = result && validationObject.indicatorMeasurement.isValid(item);
            return result;
        } else {
            return false
        }
    }
}

